exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toptitle[data-v-48355dde] {\n  padding: 10px 30px;\n  background: #1c1d1d;\n  color: white;\n  font-size: 16px;\n  text-align: center;\n}\n.toptitle a[data-v-48355dde] {\n  width: 100%;\n  display: inline-block;\n  text-decoration: none;\n  color: white;\n}", ""]);

// exports
